module.exports = __webpack_public_path__ + "static/media/jumbotron_bg.dab97eed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/stacksvault/jumbotron_bg.jpg
// module id = 984
// module chunks = 124